export enum Code {
	// Letters
	KeyA = 'KeyA',
	KeyB = 'KeyB',
	KeyC = 'KeyC',
	KeyD = 'KeyD',
	KeyE = 'KeyE',
	KeyF = 'KeyF',
	KeyG = 'KeyG',
	KeyH = 'KeyH',
	KeyI = 'KeyI',
	KeyJ = 'KeyJ',
	KeyK = 'KeyK',
	KeyL = 'KeyL',
	KeyM = 'KeyM',
	KeyN = 'KeyN',
	KeyO = 'KeyO',
	KeyP = 'KeyP',
	KeyQ = 'KeyQ',
	KeyR = 'KeyR',
	KeyS = 'KeyS',
	KeyT = 'KeyT',
	KeyU = 'KeyU',
	KeyV = 'KeyV',
	KeyW = 'KeyW',
	KeyX = 'KeyX',
	KeyY = 'KeyY',
	KeyZ = 'KeyZ',

	// Numbers
	Digit0 = 'Digit0',
	Digit1 = 'Digit1',
	Digit2 = 'Digit2',
	Digit3 = 'Digit3',
	Digit4 = 'Digit4',
	Digit5 = 'Digit5',
	Digit6 = 'Digit6',
	Digit7 = 'Digit7',
	Digit8 = 'Digit8',
	Digit9 = 'Digit9',

	// Common keys
	Enter = 'Enter',
	Escape = 'Escape',
	Backspace = 'Backspace',
	Tab = 'Tab',
	Space = 'Space',
	Minus = 'Minus',
	Equal = 'Equal',
	BracketLeft = 'BracketLeft',
	BracketRight = 'BracketRight',
	Backslash = 'Backslash',
	Semicolon = 'Semicolon',
	Quote = 'Quote',
	Comma = 'Comma',
	Period = 'Period',
	Slash = 'Slash',

	// Function keys
	F1 = 'F1',
	F2 = 'F2',
	F3 = 'F3',
	F4 = 'F4',
	F5 = 'F5',
	F6 = 'F6',
	F7 = 'F7',
	F8 = 'F8',
	F9 = 'F9',
	F10 = 'F10',
	F11 = 'F11',
	F12 = 'F12',

	// Navigation keys
	ArrowUp = 'ArrowUp',
	ArrowDown = 'ArrowDown',
	ArrowLeft = 'ArrowLeft',
	ArrowRight = 'ArrowRight',
	PageUp = 'PageUp',
	PageDown = 'PageDown',
	End = 'End',
	Home = 'Home',

	// Numpad keys
	Numpad0 = 'Numpad0',
	Numpad1 = 'Numpad1',
	Numpad2 = 'Numpad2',
	Numpad3 = 'Numpad3',
	Numpad4 = 'Numpad4',
	Numpad5 = 'Numpad5',
	Numpad6 = 'Numpad6',
	Numpad7 = 'Numpad7',
	Numpad8 = 'Numpad8',
	Numpad9 = 'Numpad9',
	NumpadMultiply = 'NumpadMultiply',
	NumpadAdd = 'NumpadAdd',
	NumpadEnter = 'NumpadEnter',
	NumpadSubtract = 'NumpadSubtract',
	NumpadDecimal = 'NumpadDecimal',
	NumpadDivide = 'NumpadDivide',
}
